const pageNameKey = "replaceBlueprintGradientBoxInfoContainer";

export const replaceBlueprintGradientBoxInfoContainerEn = {
  [pageNameKey]: {
    currentBlueprintAltText: "Current Blueprint",
    from: "from",
    by: "By",
  },
};

export const replaceBlueprintGradientBoxInfoContainerPtBr = {
  [pageNameKey]: {
    currentBlueprintAltText: "Blueprint atual",
    from: "de",
    by: "Por",
  },
};

export const replaceBlueprintGradientBoxInfoContainerDe = {
  [pageNameKey]: {
    currentBlueprintAltText: "Aktueller Blueprint",
    from: "von",
    by: "Von",
  },
};

export const replaceBlueprintGradientBoxInfoContainerZhHans = {
  [pageNameKey]: {
    currentBlueprintAltText: "当前蓝图",
    from: "从",
    by: "由",
  },
};

export const replaceBlueprintGradientBoxInfoContainerIt = {
  [pageNameKey]: {
    currentBlueprintAltText: "Blueprint corrente",
    from: "da",
    by: "Da",
  },
};

export const replaceBlueprintGradientBoxInfoContainerEs = {
  [pageNameKey]: {
    currentBlueprintAltText: "Plano actual",
    from: "de",
    by: "Por",
  },
};

export const replaceBlueprintGradientBoxInfoContainerNl = {
  [pageNameKey]: {
    by: "Door",
    currentBlueprintAltText: "Huidige blueprint",
    from: "van",
  },
};

export const replaceBlueprintGradientBoxInfoContainerTr = {
  [pageNameKey]: {
    by: "İle",
    currentBlueprintAltText: "Mevcut Plan",
    from: "itibaren",
  },
};
